import React from 'react';
import { useBiLogger } from '../hooks/useBiLogger';
import { BiEvent } from '../events';

export interface WithLogBiEventProps {
  logBiEvent(eventData: BiEvent): void;
}

export const withLogBiEvent = <T extends object>(
  Component: React.ComponentType<T>
) => {
  const ComponentWithLogBiEvent: React.FC<T> = props => {
    const logBiEvent = useBiLogger();

    return <Component {...(props as T)} logBiEvent={logBiEvent} />;
  };

  ComponentWithLogBiEvent.displayName = `WithLogBiEvent(${
    Component.displayName || Component.name || 'Component'
  })`;
  return ComponentWithLogBiEvent;
};

export default withLogBiEvent;
